import * as d3 from "d3";

export const EDGE_COLOR_PALETTE = d3.schemeTableau10 as string[];

export const buildEdgeColorScale = (domain: string[]) =>
  d3.scaleOrdinal<string, string>().domain(domain).range(EDGE_COLOR_PALETTE);
